(function(){
  'use strict';
  if(window.ArcaSetLightbox&&window.ArcaSetLightbox.version==='2'){window.ArcaSetLightbox.bind(document);return;}

  var triggerSelector='[data-arca-gallery-product], .arca-curated-bundle__image-link';
  var rootUrl=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
  var dialog=null,viewImage=null,prevButton=null,nextButton=null,counter=null,closeButton=null;
  var activeGroup=[],activeIndex=0,lastTrigger=null,touchStartX=null,requestToken=0;
  var galleryCache={};
  var lang=(document.documentElement.lang||'de').toLowerCase().slice(0,2);
  var labels=lang==='en'?{dialog:'Product gallery',close:'Close gallery',prev:'Previous image',next:'Next image',open:'Open product gallery'}:lang==='it'?{dialog:'Galleria prodotto',close:'Chiudi galleria',prev:'Immagine precedente',next:'Immagine successiva',open:'Apri galleria prodotto'}:{dialog:'Produktgalerie',close:'Galerie schließen',prev:'Vorheriges Bild',next:'Nächstes Bild',open:'Produktgalerie öffnen'};

  function bestSource(img){
    if(!img)return'';
    var srcset=img.getAttribute('srcset');
    if(srcset){
      var candidates=srcset.split(',').map(function(part){
        var bits=part.trim().split(/\s+/);var descriptor=bits[bits.length-1]||'';
        return{url:bits[0],size:parseFloat(descriptor)||0};
      }).filter(function(item){return item.url;}).sort(function(a,b){return b.size-a.size;});
      if(candidates.length)return candidates[0].url;
    }
    return img.currentSrc||img.src||'';
  }

  function productHandleFor(trigger){
    if(!trigger)return'';
    var direct=trigger.getAttribute('data-arca-gallery-product');
    if(direct)return direct;
    var href=trigger.getAttribute&&trigger.getAttribute('href');
    if(href){
      try{
        var path=new URL(href,window.location.origin).pathname;
        var match=path.match(/\/products\/([^/?#]+)/);
        if(match&&match[1])return decodeURIComponent(match[1]);
      }catch(e){}
    }
    return'';
  }

  function normaliseImage(item,title){
    if(!item)return null;
    if(typeof item==='string')return{src:item,alt:title||''};
    if(item.src)return{src:item.src,alt:item.alt||title||''};
    if(item.preview_image&&item.preview_image.src)return{src:item.preview_image.src,alt:item.alt||title||''};
    return null;
  }

  function productImages(product){
    var source=product&&Array.isArray(product.images)?product.images:[];
    if(!source.length&&product&&Array.isArray(product.media))source=product.media.filter(function(item){return !item.media_type||item.media_type==='image';});
    var seen={};
    return source.map(function(item){return normaliseImage(item,product&&product.title);}).filter(function(item){
      if(!item||!item.src||seen[item.src])return false;
      seen[item.src]=true;return true;
    });
  }

  function loadGallery(handle){
    if(galleryCache[handle])return Promise.resolve(galleryCache[handle]);
    return fetch(rootUrl+'products/'+encodeURIComponent(handle)+'.js',{headers:{Accept:'application/json'}})
      .then(function(response){if(!response.ok)throw new Error('product-gallery');return response.json();})
      .then(function(product){var images=productImages(product);if(images.length)galleryCache[handle]=images;return images;});
  }

  function ensureDialog(){
    if(dialog&&document.body.contains(dialog))return;
    dialog=document.createElement('dialog');
    dialog.className='arca-set-lightbox';
    dialog.setAttribute('aria-label',labels.dialog);
    dialog.innerHTML='<div class="arca-set-lightbox__inner"><button type="button" class="arca-set-lightbox__close" aria-label="'+labels.close+'">×</button><button type="button" class="arca-set-lightbox__nav arca-set-lightbox__prev" aria-label="'+labels.prev+'">‹</button><figure class="arca-set-lightbox__figure"><img class="arca-set-lightbox__image" alt=""></figure><button type="button" class="arca-set-lightbox__nav arca-set-lightbox__next" aria-label="'+labels.next+'">›</button><span class="arca-set-lightbox__counter" aria-live="polite"></span></div>';
    document.body.appendChild(dialog);
    viewImage=dialog.querySelector('.arca-set-lightbox__image');
    prevButton=dialog.querySelector('.arca-set-lightbox__prev');
    nextButton=dialog.querySelector('.arca-set-lightbox__next');
    closeButton=dialog.querySelector('.arca-set-lightbox__close');
    counter=dialog.querySelector('.arca-set-lightbox__counter');
    closeButton.addEventListener('click',close);
    prevButton.addEventListener('click',function(e){e.stopPropagation();show(activeIndex-1);});
    nextButton.addEventListener('click',function(e){e.stopPropagation();show(activeIndex+1);});
    dialog.addEventListener('click',function(e){if(e.target===dialog||e.target.classList.contains('arca-set-lightbox__inner'))close();});
    dialog.addEventListener('close',afterClose);
    dialog.addEventListener('touchstart',function(e){if(e.touches&&e.touches.length===1)touchStartX=e.touches[0].clientX;},{passive:true});
    dialog.addEventListener('touchend',function(e){if(touchStartX===null||!e.changedTouches||!e.changedTouches.length)return;var delta=e.changedTouches[0].clientX-touchStartX;touchStartX=null;if(Math.abs(delta)>45&&activeGroup.length>1){delta<0?show(activeIndex+1):show(activeIndex-1);}},{passive:true});
  }

  function show(index){
    if(!activeGroup.length)return;
    activeIndex=(index+activeGroup.length)%activeGroup.length;
    var image=activeGroup[activeIndex];
    viewImage.src=image.src;
    viewImage.alt=image.alt||'';
    var multiple=activeGroup.length>1;
    prevButton.hidden=!multiple;nextButton.hidden=!multiple;
    counter.textContent=multiple?(activeIndex+1)+' / '+activeGroup.length:'';
  }

  function open(trigger){
    var handle=productHandleFor(trigger);
    if(!handle)return;
    ensureDialog();
    lastTrigger=trigger;
    var img=trigger.querySelector('img');
    var fallback={src:bestSource(img),alt:img&&img.alt?img.alt:''};
    activeGroup=galleryCache[handle]&&galleryCache[handle].length?galleryCache[handle]:(fallback.src?[fallback]:[]);
    activeIndex=0;
    if(activeGroup.length)show(0);
    document.documentElement.classList.add('arca-set-lightbox-open');document.body.classList.add('arca-set-lightbox-open');
    if(typeof dialog.showModal==='function'){if(!dialog.open)dialog.showModal();}else{dialog.setAttribute('open','');}
    window.setTimeout(function(){closeButton.focus();},0);

    var token=++requestToken;
    if(galleryCache[handle]&&galleryCache[handle].length)return;
    loadGallery(handle).then(function(images){
      if(token!==requestToken||!dialog||!dialog.open||!images.length)return;
      activeGroup=images;activeIndex=0;show(0);
    }).catch(function(){});
  }

  function close(){
    if(!dialog)return;
    if(typeof dialog.close==='function'&&dialog.open){dialog.close();}else{dialog.removeAttribute('open');afterClose();}
  }

  function afterClose(){
    requestToken++;
    document.documentElement.classList.remove('arca-set-lightbox-open');document.body.classList.remove('arca-set-lightbox-open');
    if(lastTrigger&&document.body.contains(lastTrigger))lastTrigger.focus({preventScroll:true});
  }

  function onKeydown(e){
    if(!dialog||!dialog.open)return;
    if(e.key==='ArrowLeft'&&activeGroup.length>1){e.preventDefault();show(activeIndex-1);}
    if(e.key==='ArrowRight'&&activeGroup.length>1){e.preventDefault();show(activeIndex+1);}
  }

  function bind(root){
    root=root||document;
    var triggers=root.querySelectorAll?root.querySelectorAll(triggerSelector):[];
    Array.prototype.forEach.call(triggers,function(trigger){
      if(trigger.dataset.arcaLightboxBound==='v2'||!trigger.querySelector('img')||!productHandleFor(trigger))return;
      trigger.dataset.arcaLightboxBound='v2';trigger.classList.add('arca-set-lightbox-trigger');
      if(trigger.tagName!=='A'){trigger.setAttribute('role','button');trigger.setAttribute('tabindex','0');}
      var img=trigger.querySelector('img');trigger.setAttribute('aria-label',labels.open+(img&&img.alt?': '+img.alt:''));
      var hiddenParent=trigger.closest('[aria-hidden="true"]');if(hiddenParent)hiddenParent.removeAttribute('aria-hidden');
      trigger.addEventListener('click',function(e){e.preventDefault();e.stopPropagation();open(trigger);});
      trigger.addEventListener('keydown',function(e){if(e.key==='Enter'||e.key===' '){e.preventDefault();open(trigger);}});
    });
  }

  document.addEventListener('keydown',onKeydown);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){bind(document);},{once:true});else bind(document);
  document.addEventListener('shopify:section:load',function(e){bind(e.target||document);});
  window.ArcaSetLightbox={version:'2',bind:bind};
})();
